import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Snackbar,
} from '@mui/material';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import TwitterIcon from '../../../../images/TwitterIcon';

interface ShareGameDialogProps {
    open: boolean;
    onClose: () => void;
    translate: (key: string) => string;
    copyLoading: boolean;
    handleCopyShareText: () => void;
    handleShareWhatsApp: () => void;
    handleShareTwitter: () => void;
    snackbarOpen: boolean;
    setSnackbarOpen: (open: boolean) => void;
}

export default function ShareGameDialog({
    open,
    onClose,
    translate,
    copyLoading,
    handleCopyShareText,
    handleShareWhatsApp,
    handleShareTwitter,
    snackbarOpen,
    setSnackbarOpen,
}: ShareGameDialogProps) {
    return (
        <>
            <Dialog open={open} onClose={onClose}>
                <DialogTitle>{translate('shareMatch')}</DialogTitle>
                <DialogContent>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleCopyShareText}
                        startIcon={<ShareOutlinedIcon />}
                        disabled={copyLoading}
                        style={{ marginBottom: 12 }}
                        fullWidth
                    >
                        {translate('copyLink')}
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleShareWhatsApp}
                        startIcon={<WhatsAppIcon />}
                        style={{ marginBottom: 12 }}
                        fullWidth
                    >
                        {translate('ShareWhatsApp')}
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleShareTwitter}
                        startIcon={<TwitterIcon />}
                        style={{ marginBottom: 12 }}
                        fullWidth
                    >
                        {translate('ShareTwitter')}
                    </Button>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="inherit">
                        {translate('close')}
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={2000}
                onClose={() => setSnackbarOpen(false)}
                message={translate('copiedToClipboard')}
            />
        </>
    );
}
